export default class LoginModel {
  username='';

  password='';
}
